import React, { useEffect, useState } from 'react';
import useTables from '../components/hooks/useTables';
import FloorLayoutRenderer from '../components/FloorLayoutRenderer';
import CashierLoginModal from '../components/CashierLoginModal';
import api from '../api/axiosConfig';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function CashierServiceViewPage({ storeId }) {
  const { tables, fetchTables } = useTables(storeId);

  const [selectedTable, setSelectedTable] = useState(null);
  const [cashierInfo, setCashierInfo] = useState(null);
  const [cashiers, setCashiers] = useState([]);
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, getAccessToken } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !getAccessToken()) return;
    if (storeId) fetchTables();
  }, [isAuthenticated, storeId]);

  useEffect(() => {
    const fetchCashiers = async () => {
      if (!isAuthenticated || !getAccessToken()) return;

      try {
        const res = await api.get('/employee/role/cashier');
        setCashiers(res.data);
      } catch (err) {
        console.error('Failed to fetch cashiers:', err);
      }
    };

    fetchCashiers();
  }, [isAuthenticated]);

  const handleTableClick = (table) => {
    setSelectedTable(table);
    setShowLogin(true);
  };

  const handleCashierLogin = (cashier) => {
    setCashierInfo(cashier);
    setShowLogin(false);

    navigate(`/billout/${storeId}/${selectedTable._id}`, {
      state: { cashierInfo: cashier, table: selectedTable },
    });
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center py-8">
      <h2 className="text-2xl font-bold mb-6">Cashier Terminal</h2>

      <FloorLayoutRenderer
        tables={tables}
        isDraggable={false}
        isInteractive={true}
        onTableClick={handleTableClick}
      />

      <CashierLoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSuccess={handleCashierLogin}
        cashiers={cashiers}
      />
    </div>
  );
}
